module.exports = __webpack_public_path__ + "static/img/thumb_15.6dd8b5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_15.png
// module id = lRaw
// module chunks = 0